import { render, staticRenderFns } from "./FormationGesturePosture.vue?vue&type=template&id=65071968"
import script from "./FormationGesturePosture.vue?vue&type=script&lang=js"
export * from "./FormationGesturePosture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports